import { useEffect } from 'react';
import { useQuery, gql } from '@apollo/client';
import { GetMyAccountAnalytics } from './types/GetMyAccountAnalytics';
import { trackUser } from '../utils/track';
import { AccountFrag } from '../graphql/fragments';
import { useRealm } from '../context/Realm';
import { usePersistedCacheContext } from '../apollo/PersistedCacheApolloProvider';
import { useAuth } from '../context/Auth';

const GET_MY_ACCOUNT_ANALYTICS = gql`
  query GetMyAccountAnalytics {
    myAccount {
      ...AccountFields
      userType
      userHash
      isStudent
      noMarketing
      unsubscribedFromMarketing
      hardwarePreferences
      membershipType
      schools {
        name
        numLicenses
        hasSufficientSeats
        schoolContentAccess {
          realm {
            name
          }
          maxSeats
          numBuildingLicenses
          schoolMembers {
            account {
              id
            }
          }
        }
      }
      classes {
        teacherTrainingType
        name
        schoolClassMembers {
          role
        }
      }
    }
  }
  ${AccountFrag}
`;

export function useTrackUser() {
  const { isRealmLoading, realmName } = useRealm();
  const { isCacheReady } = usePersistedCacheContext();
  const { authenticated, isReady: isAuthReady } = useAuth();

  const { data: { myAccount: user } = {} } = useQuery<GetMyAccountAnalytics>(
    GET_MY_ACCOUNT_ANALYTICS,
    {
      skip: !isCacheReady || isRealmLoading || !isAuthReady || !authenticated,
      fetchPolicy: 'cache-first',
    }
  );

  useEffect(() => {
    if (isRealmLoading || !user) {
      return;
    }

    trackUser({
      ...user,
      realm: realmName,
    });
  }, [user, isRealmLoading, realmName]);
}
